import { useMutation } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { APIError } from '../../../../../../../utils'
import { importContactsCsv, ImportContactsResult } from '../query-api'

interface UseImportContactsProps {
  onError?: (error: APIError) => void
  onSuccess?: (data: ImportContactsResult) => void
}

export const useImportContacts = ({ onError, onSuccess }: UseImportContactsProps = {}) => {
  const { organization } = useUserOrganization()

  const {
    mutate: importContacts,
    isLoading: isImporting,
    data,
    error,
    reset,
  } = useMutation<ImportContactsResult, APIError, File>(
    (file: File) => importContactsCsv(organization?.id as string, file),
    { onSuccess, onError },
  )

  return { importContacts, isImporting, importResult: data, error, reset }
}
